import useModalEvent from "../../hooks/useModalEvent";
import { useTranslation } from "react-i18next";
import useEvent from "../../hooks/useEvent";
import { formatDate } from "../../utils/helpers";
import { DateFormats } from "../../types/DateFormats";
import { Button } from "@etframework/ui.components";

export const ExtensionContainer = ({
  isTaxReturn,
  task,
  canModifyTasks,
  visualStatusRef,
}) => {
  const { ModalEvents, toggleModal } = useModalEvent();
  const { Events, useRegisterCustomEvent } = useEvent();
  const { t } = useTranslation(["Overlay"]);

  const extendedDate = task?.TaskTaxReturnInfo?.ExtendedTaxDeadline;

  const onCloseExtendedDateModal = () => {
    if (visualStatusRef) visualStatusRef.current.extendedDate = false;
  };

  useRegisterCustomEvent(
    Events.ClosingExtendedDateModal,
    onCloseExtendedDateModal
  );

  const setExtendedDate = async () => {
    if (visualStatusRef) visualStatusRef.current.extendedDate = true;
    toggleModal(ModalEvents.ExtendedDateModal, {
      task: task,
    });
  };

  const undoExtendedDate = async () => {
    if (visualStatusRef) visualStatusRef.current.extendedDate = true;
    toggleModal(ModalEvents.UndoExtendedDateModal, {
      task: task,
    });
  };

  const ExtensionModalButton = ({ id, onClick, label, icon }) => {
    return (
      <Button
        id={id}
        text={label}
        className="btn-tertiary w-auto fw-400 border rounded "
        onClick={onClick}
        iconCss={icon}
      />
    );
  };

  return (
    <>
      {isTaxReturn == 1 &&
        canModifyTasks &&
        (extendedDate == null ? (
          <div className="d-flex justify-content-start h-fit align-self-end align-items-center m-2">
            <ExtensionModalButton
              id="apply-extension-modal-btn"
              onClick={setExtendedDate}
              label={t("ApplyExtension")}
              icon="fa-regular fa-calendar-day"
            />
          </div>
        ) : (
          <div className="m-3">
            <p className="et-darkest-gray fst-italic">
              {t("TaxReturnOriginallyDueFor")}{" "}
              {formatDate(
                task?.TaskTaxReturnInfo?.TaxDeadline,
                DateFormats.ShortDateFormat.momentJsFormat
              )}
            </p>
            <div className="d-flex justify-content-start align-items-center">
              <ExtensionModalButton
                id="undo-extension-modal-btn"
                onClick={undoExtendedDate}
                label={t("UndoExtension")}
                icon="fa-regular fa-calendar-xmark"
              />
            </div>
          </div>
        ))}
    </>
  );
};
